export const LOGIN_USER_START = 'login_user_start';
export const LOGIN_USER_SUCCESS = 'login_user_success';
export const LOGIN_USER_FAIL = 'login_user_fail';
export const FETCH_TOKEN = 'fetch_token';
export const LOAD_FETCHING = 'load_fetching';
export const LOAD_GET_DATA = 'load_get_data';
export const GET_DATA_START = 'get_data_start';
export const GET_DATA_SUCCESS = 'get_data_success';
export const GET_DATA_FAIL = 'get_data_fail';
export const GET_QUARTER_DATA_SUCCESS = 'get_quarter_data_success';
export const GET_QUARTER_DATA_START = 'get_quarter_data_starts';
export const GET_QUARTER_CHART_START = 'get_quarter_chart_start';
export const GET_QUARTER_CHART_SUCCESS = 'get_quarter_chart_success';
export const GET_QUARTER_DSP_CHART_START = 'get_quarter_dsp_chart_start';
export const GET_QUARTER_DSP_CHART_SUCCESS = 'get_quarter_dsp_chart_success';
export const GET_QUARTER_TERRITORY_CHART_START = 'get_quarter_territory_chart_start';
export const GET_QUARTER_TERRITORY_CHART_SUCCESS = 'get_quarter_territory_chart_success';
export const GET_ASSET_PROFILE_START = 'get_asset_profile_start';
export const GET_ASSET_PROFILE_SUCCESS = 'get_asset_profile_success';
export const GET_TOPS_QUARTER_START = 'get_tops_quarter_start';
export const GET_TOPS_QUARTER_SUCCESS = 'get_tops_quarter_success';
export const FORGOT_PASSWORD_SENT = 'forgot_password_sent';
export const CHANGE_PASSWORD_SUCCEESS = 'change_password_success';
export const RESET_PASSWORD_SUCCEESS = 'reset_password_success';
export const GET_FIRST_LOGIN_INFO = 'get_first_login_info';
export const LOGOUT_USER = 'logout_user';
export const RESET_PASSWORD_FAIL = 'reset_password_fail';
export const GET_QUARTER_TERRITORY_CHART_STREAMS_START = 'get_quarter_territory_chart_streams_start';
export const GET_QUARTER_TERRITORY_CHART_STREAMS_SUCESS = 'get_quarter_territory_chart_streams_sucess';
export const GET_QUARTER_TERRITORY_CHART_DOWNLOADS_START = 'get_quarter_territory_chart_downloads_start';
export const GET_QUARTER_TERRITORY_CHART_DOWNLOADS_SUCESS = 'get_quarter_territory_chart_downloads_sucess';
export const GET_QUARTER_TERRITORY_CHART_STREAMS_ISRC_START = 'get_quarter_territory_chart_streams_isrc_start';
export const GET_QUARTER_TERRITORY_CHART_STREAMS_ISRC_SUCESS = 'get_quarter_territory_chart_streams_isrc_sucess';
export const GET_QUARTER_TERRITORY_CHART_DOWNLOADS_ISRC_START = 'get_quarter_territory_chart_downloads_isrc_start';
export const GET_QUARTER_TERRITORY_CHART_DOWNLOADS_ISRC_SUCESS = 'get_quarter_territory_chart_downloads_isrc_sucess';
export const GET_ISRC_DSP_CHART_START = 'get_isrc_dsp_chart_start';
export const GET_ISRC_DSP_CHART_SUCESS = 'get_isrc_dsp_chart_success';
export const GET_ISRC_CHART_DATE_START = 'get_isrc_chart_date_start';
export const GET_ISRC_CHART_DATE_SUCESS = 'get_isrc_chart_date_sucess';
export const GET_QUARTER_ACTIVITY_CHART_START = 'GET_QUARTER_ACTIVITY_CHART_START';
export const GET_QUARTER_ACTIVITY_CHART_SUCCESS = 'GET_QUARTER_ACTIVITY_CHART_SUCCESS';
export const GET_IMPERSONATION_LIST_START = "GET_IMPERSONATION_LIST_START";
export const GET_IMPERSONATION_LIST_SUCCESS = "GET_IMPERSONATION_LIST_SUCCESS";
export const SET_IMPERSONATION_LIST_START = "SET_IMPERSONATION_LIST_START";
export const SET_IMPERSONATION_LIST_SUCCESS = "SET_IMPERSONATION_LIST_SUCCESS";
export const SET_AUDIOURL = "SET_AUDIOURL";
export const SORT_TEMP_SHORTLIST = "SORT_TEMP_SHORTLIST";
export const REQUEST_UPDATE_SHORTLIST = "REQUEST_UPDATE_SHORTLIST";
export const RECEIVE_UPDATE_SHORTLIST = "RECEIVE_UPDATE_SHORTLIST";
export const RECEIVE_AUTOCOMPLETE_SHORTLIST = "RECEIVE_AUTOCOMPLETE_SHORTLIST";
export const REQUEST_AUTOCOMPLETE_SHORTLIST = "REQUEST_AUTOCOMPLETE_SHORTLIST";
export const SELECT_TRACK = "SELECT_TRACK";
export const REQUEST_SHORTLIST_DRAFT = "REQUEST_SHORTLIST_DRAFT";
export const RECEIVE_SHORTLIST_DRAFT = "RECEIVE_SHORTLIST_DRAFT";
export const SET_SHORTLIST = "SET_SHORTLIST";
export const SET_SHORTLIST_NAME = "SET_SHORTLIST_NAME";
export const REQUEST_CREATE_SHORTLIST = "REQUEST_CREATE_SHORTLIST";
export const RECEIVE_CREATE_SHORTLIST = "RECEIVE_CREATE_SHORTLIST";
export const RECEIVE_SHORTLIST_ANALYSIS = "RECEIVE_SHORTLIST_ANALYSIS";
export const REQUEST_SHORTLIST_ANALYSIS = "REQUEST_SHORTLIST_ANALYSIS";
export const MODIFY_SHORTLIST = "MODIFY_SHORTLIST";
export const SET_TAB = "SET_TAB";
export const SET_SHORTLIST_ISRC = "SET_SHORTLIST_ISRC";
export const SET_CATALOG_FILTER = "SET_CATALOG_FILTER";
export const SET_CATALOG_SELECTED = "SET_CATALOG_SELECTED";
export const SET_GENRES_SELECTED = "SET_GENRES_SELECTED";
export const REQUEST_READY_SHORTLIST = "REQUEST_READY_SHORTLIST";
export const RECEIVE_READY_SHORTLIST = "RECEIVE_READY_SHORTLIST";
export const REQUEST_DELETE_SHORTLIST = "REQUEST_DELETE_SHORTLIST";
export const RECEIVE_DELETE_SHORTLIST = "RECEIVE_DELETE_SHORTLIST";
export const CLEAR_SHORTLIST = "CLEAR_SHORTLIST";
export const GET_UPC_DATA = "GET_UPC_DATA";
export const UPC_DATA_SUCCESS = "UPC_DATA_SUCCESS";
export const GET_RELEASE_DATA = "GET_RELEASE_DATA";
export const RELEASE_DATA_SUCCESS = "RELEASE_DATA_SUCCESS";
export const RECEIVE_NAME_SHORTLIST = "RECEIVE_NAME_SHORTLIST";
export const REQUEST_NAME_SHORTLIST = "REQUEST_NAME_SHORTLIST";
export const SET_SHORTLIST_BY_STATE = "SET_SHORTLIST_BY_STATE";
export const RECEIVE_SHORTLIST_ANALYSIS_INTERNAL = "RECEIVE_SHORTLIST_ANALYSIS_INTERNAL";
export const SET_UPCS_TERRITORIES = "SET_UPCS_TERRITORIES";
export const REQUEST_TERRITORY_CHANGE = "REQUEST_TERRITORY_CHANGE";
export const REQUEST_TERRITORY_CHANGE_SUCCESS = "REQUEST_TERRITORY_CHANGE_SUCCESS";
//REQUEST_ASSET_TAGS_LIST,
//    RECEIVE_ASSET_TAGS_LIST,
//    REQUEST_AUTOCOMPLETE_TAGS,
//    RECEIVE_AUTOCOMPLETE_TAGS,
//    REQUEST_SAVE_TAGS,
//    RECEIVE_SAVE_TAGS
export const REQUEST_ASSET_TAGS_LIST = "REQUEST_ASSET_TAGS_LIST";
export const RECEIVE_ASSET_TAGS_LIST = "RECEIVE_ASSET_TAGS_LIST";
export const REQUEST_AUTOCOMPLETE_TAGS = "REQUEST_AUTOCOMPLETE_TAGS";
export const RECEIVE_AUTOCOMPLETE_TAGS = "RECEIVE_AUTOCOMPLETE_TAGS";
export const REQUEST_SAVE_TAGS = "REQUEST_SAVE_TAGS";
export const RECEIVE_SAVE_TAGS = "RECEIVE_SAVE_TAGS";
export const SET_MOODS = "SET_MOODS";
export const REQUEST_PUBLISH_PRODUCT = "REQUEST_PUBLISH_PRODUCT";
export const REQUEST_PUBLISH_PRODUCT_SUCCESS = "REQUEST_PUBLISH_PRODUCT_SUCCESS";
export const SET_UPCS_PUBLISH = "SET_UPCS_PUBLISH";
//REQUEST_CATALOG_CHANGE,
//    REQUEST_CATALOG_CHANGE_SUCCESS,
//    SET_CATALOG_CODES
export const SET_CATALOG_CODES = "SET_CATALOG_CODES";
export const REQUEST_CATALOG_CHANGE = "REQUEST_CATALOG_CHANGE";
export const REQUEST_CATALOG_CHANGE_SUCCESS = "REQUEST_CATALOG_CHANGE_SUCCESS";
//REQUEST_MASS_PRODUCT_CHANGE,
//    REQUEST_MASS_PRODUCT_SUCCESS,
//    SET_MASS_PRODUCT_CODES,
export const REQUEST_MASS_PRODUCT_CHANGE = "REQUEST_MASS_PRODUCT_CHANGE";
export const REQUEST_MASS_PRODUCT_SUCCESS = "REQUEST_MASS_PRODUCT_SUCCESS";
export const SET_MASS_PRODUCT_CODES = "SET_MASS_PRODUCT_CODES";
export const SELECT_PRODUCT_FOR_UPDATE = "SELECT_PRODUCT_FOR_UPDATE";
//REQUEST_SINGLE_PRODUCT_CHANGE,
//    REQUEST_SINGLE_PRODUCT_CHANGE_SUCCESS
export const REQUEST_SINGLE_PRODUCT_CHANGE = "REQUEST_SINGLE_PRODUCT_CHANGE"
export const REQUEST_SINGLE_PRODUCT_CHANGE_SUCCESS = "REQUEST_SINGLE_PRODUCT_CHANGE_SUCCESS"

export const RECEIVE_GENRE_SHORTLIST = "RECEIVE_GENRE_SHORTLIST";
export const REQUEST_GENRE_SHORTLIST = "REQUEST_GENRE_SHORTLIST";
export const RECEIVE_SUBGENRE_SHORTLIST = "RECEIVE_SUBGENRE_SHORTLIST";
export const REQUEST_SUBGENRE_SHORTLIST = "REQUEST_SUBGENRE_SHORTLIST";

//SET_SHORTLIST_GENRE,
//    SET_SHORTLIST_SUBGENRE

export const SET_SHORTLIST_GENRE = "SET_SHORTLIST_GENRE";
export const SET_SHORTLIST_SUBGENRE = "SET_SHORTLIST_SUBGENRE";

export const REQUEST_UPDATE_PRODUCT = "REQUEST_UPDATE_PRODUCT";
export const REQUEST_UPDATE_PRODUCT_SUCCESS = "REQUEST_UPDATE_PRODUCT_SUCCESS";
export const SET_UPCS_UPDATE = "SET_UPCS_UPDATE";

export const REQUEST_UPDATE_ASSET = "REQUEST_UPDATE_ASSET";
export const REQUEST_UPDATE_ASSET_SUCCESS = "REQUEST_UPDATE_ASSET_SUCCESS";
export const SET_ISRCS_UPDATE = "SET_ISRCS_UPDATE";

export const REQUEST_UPDATE_LOP = "REQUEST_UPDATE_LOP";
export const REQUEST_UPDATE_LOP_SUCCESS = "REQUEST_UPDATE_LOP_SUCCESS";
export const SET_UPCS_LOP_UPDATE = "SET_UPCS_LOP_UPDATE";

export const GET_SYNC_DATA = "GET_SYNC_DATA";
export const GET_SYNC_DATA_SUCCESS = "GET_SYNC_DATA_SUCCESS";
export const SELECT_SYNC_TRACK = "SELECT_SYNC_TRACK";
export const SET_TAB_SYNC = "SET_TAB_SYNC";

//REQUEST_UPDATE_LYRICIST,
//    REQUEST_UPDATE_LYRICIST_SUCCESS,
//    SET_UPCS_LYRICIST_UPDATE,

export const REQUEST_UPDATE_LYRICIST = "REQUEST_UPDATE_LYRICIST";
export const REQUEST_UPDATE_LYRICIST_SUCCESS = "REQUEST_UPDATE_LYRICIST_SUCCESS";
export const SET_UPCS_LYRICIST_UPDATE = "SET_UPCS_LYRICIST_UPDATE";
export const SET_FILTER_GENRE = "SET_FILTER_GENRE";
export const SET_FILTER_TITLE = "SET_FILTER_TITLE"
export const SET_FILTER_ISRC = "SET_FILTER_ISRC"

export const GET_ML_TAGS = "GET_ML_TAGS"
export const GET_ML_TAGS_SUCCESS = "GET_ML_TAGS_SUCCESS"

export const SET_TAG_ML_VERIFIED = "SET_TAG_ML_VERIFIED"
export const SET_TAG_ML_VERIFIED_SUCCESS = "SET_TAG_ML_VERIFIED_SUCCESS"

export const SET_TAG_ML_SHOW = "SET_TAG_ML_SHOW"
export const SET_TAG_ML_SHOW_SUCCESS = "SET_TAG_ML_SHOW_SUCCESS"
export const SET_ML_ASSET_SELECTED = "SET_ML_ASSET_SELECTED"



// WEBPACK FOOTER //
// ./src/store/Types.js